import { configureStore } from "@reduxjs/toolkit";
import { signupSlice } from "./slices/signupSlice";
import { userSlice } from "./slices/userSlice";
import { missingFieldsSlice } from "./slices/missingFieldsSlice";
import { flowSlice } from "./slices/flowSlice";
import { olkypassSlice } from "./slices/olkypassSlice";
import { kycSessionSlice } from "./slices/kycSession";
import { tokenSlice } from "./slices/tokenSlice";
import { transfertActionSlice } from "./slices/transfertActionSlice";
import { companyonboardingSlice } from "./slices/companyOnboardingSlice";
import { adminSlice } from "./slices/adminSlice";

export const store = configureStore({
  reducer: {
    signup: signupSlice.reducer,
    user: userSlice.reducer,
    missingFields: missingFieldsSlice.reducer,
    flow: flowSlice.reducer,
    olkypass: olkypassSlice.reducer,
    kycSession: kycSessionSlice.reducer,
    token: tokenSlice.reducer,
    transfertActions: transfertActionSlice.reducer,
    companyOnboarding: companyonboardingSlice.reducer,
    admin: adminSlice.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
